var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8333 3.33329H15V2.49996C15 2.04163 14.625 1.66663 14.1667 1.66663C13.7083 1.66663 13.3333 2.04163 13.3333 2.49996V3.33329H6.66667V2.49996C6.66667 2.04163 6.29167 1.66663 5.83333 1.66663C5.375 1.66663 5 2.04163 5 2.49996V3.33329H4.16667C3.24167 3.33329 2.50833 4.08329 2.50833 4.99996L2.5 16.6666C2.5 17.5833 3.24167 18.3333 4.16667 18.3333H15.8333C16.75 18.3333 17.5 17.5833 17.5 16.6666V4.99996C17.5 4.08329 16.75 3.33329 15.8333 3.33329ZM15.8333 15.8333C15.8333 16.2917 15.4583 16.6667 15 16.6667H5C4.54167 16.6667 4.16667 16.2917 4.16667 15.8333V7.5H15.8333V15.8333Z",
    fill: "#EE4F4F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.90073 14.9999L7.08203 14.1812L9.18727 12.0759L7.08203 9.98533L7.90073 9.16663L10.006 11.2719L12.0966 9.16663L12.9153 9.98533L10.81 12.0759L12.9153 14.1812L12.0966 14.9999L10.006 12.8946L7.90073 14.9999Z",
    fill: "#EE4F4F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarCross);
export default __webpack_public_path__ + "static/media/Calendar-Cross.db4019652608fa07144b1fffa6f4db3a.svg";
export { ForwardRef as ReactComponent };